function InitialiseHeader()
{
    $('.pw-header-announcement-target').slick({
        infinite: true,
        autoplay: true, 
        autplaySpeed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: $('.announcement-next-arrow'),
        prevArrow: $('.announcement-prev-arrow')
      });
}

function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function showNavMenu( element )
{
    var parent          = SearchParentsFor( element, "pw-nav-link" );
    var targetcontainer = parent.querySelector( ".pw-nav-menu-option-container" );
    var allContainers   = document.querySelectorAll( ".pw-nav-menu-option-container" );
    var underlay        = document.querySelector( ".pw-nav-menu-underlay" );

    for( var i = 0; i < allContainers.length; i++ )
    {
        var singleContainer = allContainers[ i ];
        singleContainer.style.opacity = "0";
        singleContainer.style.zIndex = "-99";
    }

    if( targetcontainer.style.opacity = "0" )
    {
        targetcontainer.style.opacity = "1";
        targetcontainer.style.transition = "opacity 500ms";
        targetcontainer.style.zIndex = "50";
        targetcontainer.style.pointerEvents = "auto";
    }
    else if( targetcontainer.style.opacity = "1" )
    {
        targetcontainer.style.opacity = "0";
        targetcontainer.style.transition = "opacity 500ms";
        targetcontainer.style.zIndex = "-99";        
    }

    underlay.classList.remove( "hidden" );
}

function hideNavMenu( element )
{
    var navMenus   = document.querySelectorAll( ".pw-nav-menu-option-container" );

    for( var i = 0; i < navMenus.length; i++ )
    {
        var navMenu = navMenus[ i ];
        navMenu.style.opacity = "0";
        navMenu.style.zIndex = "-99";
    }

   // element.classList.add( "hidden" );
}

function openMobNav( element )
{
    var navMenu      = document.querySelector( ".pw-mob-nav-menu-parent" );
    var mobUnderlay  = document.querySelector( ".pw-nav-menu-underlay-mob" );

    navMenu.style.opacity = "1";
    navMenu.style.transition = "opacity 500ms";
    navMenu.style.zIndex = "100";
    navMenu.style.pointerEvents = "auto";

    mobUnderlay.style.display = "block";
    mobUnderlay.style.opacity = "0.2";
    mobUnderlay.style.transition = "opacity 500ms";
    mobUnderlay.style.zIndex = "99";
    mobUnderlay.style.pointerEvents = "auto";
}

function closeMobNav( element )
{
    console.log('hello mob nav');

    var navMenu      = SearchParentsFor( element, "pw-mob-nav-menu-parent" );
    var mobUnderlay  = document.querySelector( ".pw-nav-menu-underlay-mob" );

    console.log(mobUnderlay, 'underlay')

    // navMenu.classList.toggle( "no-opacity", true );
    navMenu.style.opacity = "0";
    navMenu.style.transition = "opacity 500ms";
    navMenu.style.zIndex = "-99";
    navMenu.style.pointerEvents = "none";

    // mobUnderlay.classList.toggle( "no-opacity", true );
    mobUnderlay.style.opacity = "0";
    mobUnderlay.style.transition = "opacity 500ms";
    mobUnderlay.style.zIndex = "-99";
    mobUnderlay.style.pointerEvents = "none";
}

function showMobNavChild( element )
{
    var parent = SearchParentsFor( element, "pw-mob-nav-menu-parent-item" );
    var childNavMenu = parent.querySelector( ".pw-mob-nav-menu-child" );

    console.log( element );
    console.log(childNavMenu)

    childNavMenu.style.opacity = "1";
    childNavMenu.style.transition = "opacity 500ms";
    childNavMenu.style.zIndex = "101";
    childNavMenu.style.transform = "none";
    childNavMenu.classList.toggle( "velocity-animating", false )

}

function closeMobNavChild( element )
{
    console.log('close child nav');

    var childNavs = document.querySelectorAll( ".pw-mob-nav-menu-child" );
    console.log(childNavs, 'CHILD NAVS')

    for( var i = 0; i < childNavs.length; i++ )
    {
        childNav = childNavs[ i ];
        childNav.style.opacity = "0";
        childNav.style.transition = "opacity 500ms";
        childNav.style.zIndex = "-99";
    }
}

function revealSignInForm( element )
{
    var closeIcon = document.querySelector( ".close-mob-nav-icon" );
    closeMobNav( closeIcon );

    var loginForm = document.querySelector( ".mob-login-form-container" );
    var loginUnderlay = document.querySelector( ".login-form-underlay" );

    loginForm.style.opacity = "1";
    loginForm.style.transition = "opacity 500ms";
    loginForm.style.zIndex = "10";
    loginForm.style.pointerEvents = "auto";

    loginUnderlay.style.opacity = "0.2";
    loginUnderlay.style.transition = "opacity 500ms";
    loginUnderlay.style.zIndex = "9";
    loginUnderlay.style.pointerEvents = "auto";

}

function hideSignInForm( element )
{
    var loginForm = document.querySelector( ".mob-login-form-container" );
    var loginUnderlay = document.querySelector( ".login-form-underlay" );
    var navUnderlay = document.querySelector( ".pw-nav-menu-underlay-mob" );

    loginForm.style.opacity = "0";
    loginForm.style.transition = "opacity 500ms";
    loginForm.style.zIndex = "-99";

    loginUnderlay.style.opacity = "0";
    loginUnderlay.style.transition = "opacity 500ms";
    loginUnderlay.style.zIndex = "-99";

    // loginUnderlay.style.display = "none";
    navUnderlay.style.opacity = "0";
    navUnderlay.style.transition = "opacity 500ms";
    navUnderlay.style.zIndex = "-99";
}

window.addEventListener( "DOMContentLoaded", function()
{
    InitialiseHeader();
} );    